// extracted by mini-css-extract-plugin
export default {"root":"_3uigoR-q","tag":"_34ObI6Rc","copied":"_1zkIvY7j","button":"_3NDnp4Xh","legacy":"_1HJ5Grla"};